import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type PaymentControllerStore = {
  isDetailOpen: boolean
  autoFocusDiscount: boolean
  paymentStep: number
  setPaymentStep(paymentStep: number): void
  setDetailOpen(isDetailOpen: boolean): void
  setAutoFocusDiscount(autoFocusDiscount: boolean): void
  reset(): void
}

const initialState = {
  isDetailOpen: false,
  autoFocusDiscount: false,
  paymentStep: 1,
}

export const usePaymentStore = create<PaymentControllerStore>()(
  persist(
    (set) => ({
      ...initialState,
      setPaymentStep: (paymentStep: number) =>
        set(() => ({
          paymentStep,
        })),
      setDetailOpen: (isDetailOpen: boolean) =>
        set(() => ({
          isDetailOpen,
        })),
      setAutoFocusDiscount: (autoFocusDiscount: boolean) =>
        set(() => ({
          autoFocusDiscount,
        })),
      reset: () => {
        set({ ...initialState })
      },
    }),
    {
      name: 'pay-controller-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
